// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2G6Km","icon":"SortAdornment_icon__D6-pu","up":"SortAdornment_up__3pgaP","down":"SortAdornment_down__9c5IZ","active":"SortAdornment_active__2UJNC"};